import { List } from '../objects/list';
import { Currency } from '../objects/currency';

export const SET_CONVERT_TO = 'CURRENCY_SET_CONVERT_TO';
export const SET_EXPORT_TYPE = 'CURRENCY_SET_EXPORT_TYPE';
export const SET_LIMIT = 'CURRENCY_SET_LIMIT';
export const SET_LIST = 'CURRENCY_SET_LIST';
export const SET_PAGE = 'CURRENCY_SET_PAGE';
export const SET_RUNNING = 'CURRENCY_SET_RUNNING';
export const SET_SEARCH = 'CURRENCY_SET_SEARCH';
export const TOGGLE_EXPORT = 'CURRENCY_TOGGLE_EXPORT';
export const TOGGLE_EXPORT_FULL = 'CURRENCY_TOGGLE_EXPORT_FULL';
export const TOGGLE_FILTERS = 'CURRENCY_TOGGLE_FILTERS';
export const TOGGLE_REFRESH = 'CURRENCY_TOGGLE_REFRESH';

interface SetConvertToAction {
    type: typeof SET_CONVERT_TO,
    payload: Currency
}

interface SetExportTypeAction {
    type: typeof SET_EXPORT_TYPE,
    payload: 'CSV' | 'PDF'
}

interface SetLimitAction {
    type: typeof SET_LIMIT,
    payload: number
}

interface SetListAction {
    type: typeof SET_LIST,
    payload: List
}

interface SetPageAction {
    type: typeof SET_PAGE,
    payload: number
}

interface SetRunningAction {
    type: typeof SET_RUNNING,
    payload: boolean
}

interface SetSearchAction {
    type: typeof SET_SEARCH,
    payload: string
}

interface ToggleExportAction {
    type: typeof TOGGLE_EXPORT,
    payload: boolean
}

interface ToggleExportFullAction {
    type: typeof TOGGLE_EXPORT_FULL
}

interface ToggleFiltersAction {
    type: typeof TOGGLE_FILTERS
}

interface ToggleRefreshAction {
    type: typeof TOGGLE_REFRESH
}

export type CurrencyActionTypes =
    SetConvertToAction |
    SetExportTypeAction |
    SetLimitAction |
    SetListAction |
    SetPageAction |
    SetRunningAction |
    SetSearchAction |
    ToggleExportAction |
    ToggleExportFullAction |
    ToggleFiltersAction |
    ToggleRefreshAction;